import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import data from './data'
import type { QuizSchema } from './schema'
import { quizSchema } from './schema'

const useQuizForm = () =>
  useForm<QuizSchema>({
    resolver: zodResolver(quizSchema),
    mode: `onChange`,
    defaultValues: {
      answers: data.map(() => ``),
    },
  })

export default useQuizForm
